<template>
  <div>
    <template v-for="navi in navis">
      <el-link :key="navi.tab" type="primary" @click="tab = navi.tab">
        {{ navi.label }}
      </el-link>
      &nbsp;
    </template>

    <div v-show="tab == 0">
      <monitor-data
        v-if="sn"
        :sn="sn"
        ref="MonitorData"
        style="margin-top: 10px"
      />
    </div>
    <div v-show="tab == 1">
      <monitor-control
        ref="MonitorControl"
        :land-id="landId"
        style="margin-top: 10px"
      />
    </div>
    <!-- <div v-show="tab == 2">
      <monitor-irrigate :irrigate-sn="irrigateSn" style="margin-top: 10px" />
    </div> -->
  </div>
</template>
<script>
import MonitorIrrigate from './MonitorIrrigate'
import MonitorData from './MonitorData'
import MonitorControl from './MonitorControl'
import { getDeviceInfoByLand, getDevicesByParkId } from '@/api/equip.js'
import { searchUrl, getEquipData } from '@/api/equipControl.js'
export default {
  name: 'MonitorOfLand',
  components: { MonitorData, MonitorControl, MonitorIrrigate },
  props: {
    landId: { type: Number, required: false },
    irrigateSn: { type: String, required: false },
  },
  data() {
    return {
      tab: 0,
      // irrigateSn: undefined,
      sn: undefined,
      navis: [
        {
          label: '数据',
          tab: 0,
        },
        {
          label: '控制',
          tab: 1,
        },
        // {
        //   label: '水肥',
        //   tab: 2,
        // },
      ],
    }
  },
  watch: {
    landId(val) {
      console.log('landId = ', val)
      this.tab = 0
      getDeviceInfoByLand(val).then((resp) => {
        let obj = resp.data.find((item) => item.model == 'monitor')
        this.sn = obj ? obj.sn : undefined

        this.$nextTick(() => {
          this.$refs.MonitorControl.controlDeviceGet(this.sn)
          this.$refs.MonitorData.getUrl(this.sn)
        })
      })
    },
  },
  methods: {},
}
</script>


// WEBPACK FOOTER //
// src/components/monitor/environment/MonitorOfLand.vue